<template>
  <div class="mb-50 fabricationContainer">
    <div class="row justify-content-start justify-content-sm-end flex-sm-row flex-column">
      <div
          class="col-lg-6 col"
          data-aos="fade-left"
          data-aos-duration="1200"
      >
        <div class="text-wrapper d-flex flex-column">
          <div>
            <h2>
              La Fabrication
            </h2>
          </div>
          <p class="mb-20">
            Intégralement effectuée dans notre usine de Séméac elle se décompose en plusieurs étape :
          </p>
          <p class="mb-20">
            Bobinage, tressage , laçage et thermo-fixation des nœuds par cuisson à la vapeur d’eau. Altela est la
            seule entreprise en France à le faire. Cela nous apporte réactivité et qualité tout en restant dans les
            prix du marché.
          </p>
          <p>
            <button class="btn-red">
              Voir la video <i class="fa-solid fa-play"></i>
            </button>
          </p>
        </div>
        <!-- /.text-wrapper -->
      </div>
      <div
          class="col-lg-6 col position-relative video"
          data-aos="fade-right"
          data-aos-duration="1200"
      >
        <img
            src="/images/altela-img/entreprise/fabrication.png"
            alt=""
            class="imgPost"
        />
        <i class="fa-solid fa-play position-absolute"></i>
      </div>
    </div>
  </div>
</template>
<script setup>
</script>
<style scoped>

.row.align-items-center {
  column-gap: 2rem;
}

.text-wrapper {
  padding: 3.75rem;
  border-radius: 0.625rem;
  row-gap: 2rem;
  color: #fff;
}

.text-wrapper h2 {
  color: #fff;
  font-family: Panton;
  font-size: 2.0625rem;
  font-style: italic;
  font-weight: 400;
  line-height: 110%; /* 2.26875rem */
  letter-spacing: 0.04125rem;
  text-transform: uppercase;
}

.text-wrapper p {
  font-family: Roboto;
  font-size: 1.1875rem;
  font-style: normal;
  font-weight: 400;
  line-height: 144%; /* 1.71rem */
  letter-spacing: 0.02375rem;
}

.col-lg-6:nth-child(1) {
  width: 40%;
}

.imgPost {
  width: 100%;
  //max-height: 32rem;
  height: 100%;
  object-fit: cover;
  box-shadow: 0px 11px 27px 0px rgba(0, 0, 0, 0.19);
}

.borderRadiusReverse {
  border-radius: 1.25rem 0rem 0rem 1.25rem;
}

.fabricationContainer {
  background: #093888;
}

.btn-red {
  padding: 0.9375rem 1.5625rem;
  border-radius: 0.3125rem;
  background: var(--primaire, #D9000D);
  text-transform: uppercase;
  color: #fff;
  display: flex;
  align-items: center;
  column-gap: 1rem;
}

.video i {
  top: 35%;
  left: 50%;
  color: #fff;
  font-size: 5rem;
}

@media screen and (max-width: 810px) {
  .col-lg-6:nth-child(1) {
    width: initial;
  }

  .imgPost {
    border-radius: initial;
  }

  .video i {
    left: 47%;
    font-size: 3rem;
  }

  .btn-red, .text-wrapper p {
    font-size: 15px;
  }

  .text-wrapper h2 {
    font-size: 20px;
  }
}

</style>